export const RESPONSE_ACTION_MAPPING = {
    data_exempt: "Data Exempt by Policy",
    error: "Error",
    unable_to_retrieve: "Error",
    not_found: "Record Not Found",
    success: "Success"
};
 export const TOYOTA_CONNECTED_NAMES = ["Servco", "Qualtrics", "DriverWaiver", "HireVue", "ITGFLEET", "WeaveGrid", "EnergyHub", "SXM2"]
 export const TMNA_SERVICENOW = [
        'Service Connect',
        'Customer Care-AMS',
        'CT-BI',
        'Customer Care-Sustainment',
    ]